import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { DealPageHelper } from "../Helpers/DealPageHelper.js";
import { Modal } from "./Modal.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";

export class TradeInSection {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "tradein-section";
        this.imagesTradeIn = [];
        this.includeTradeIn = true;
        this.includeTradeInTouched = false; //true once the customer changes the dropdown from whatever it loaded with
        this.enabled = true;
        this.videoRemovedSTs = [
            "bmwmcriverside", "powersportsofmodesto", "motorcyclesofmiami", "victorcdjrdemo", "rgvcycles"
        ];
        this.FCAMakeList = [];
        this.tradeInEventFired = {};//key=>bool

    }

    init(containerElement) {
        containerElement.insertAdjacentHTML("beforeend", this.getHtml());
        this.hideOrShowVideo();

        // video trade in modal
        this.videosModal = new Modal(
            this.app,
            "start-videos-tradein-modal",
            this.getVideoModalHtml(),
            null,
            "videos-tradein-class"
        );
        this.videosModal.init();

        // video images trade in modal
        this.videoImagesModal = new Modal(
            this.app,
            "start-videos-images-modal",
            this.getVideoImagesModalHtml(),
            null,
            "images-trade-in-class"
        );
        this.videoImagesModal.init();

        // drap and drop modal
        this.dragdropModal = new Modal(
            this.app,
            "start-drag-and-drop-modal",
            this.getDragAndDropHtml(),
            null,
            "drag-drop-class"
        );
        this.dragdropModal.init();

        this.eventHandlers();

        this.setVideos();
        // this.hideTradeInValueInformation();
        this.hideOrShowEstimatedTradeInValue();

        this.populateTradeInSelect();
    }

    populateTradeInSelect() {
        let isDucati = this.app.config.vehicle.make.toLowerCase() == "ducati";
        if ((this.app.dealPage.getTradeInEnable() && this.app.isBMW()) ||
            (this.app.dealPage.getTradeInEnable() && isDucati) ||
            (this.app.dealPage.getTradeInEnable() && this.app.isBMWPolaris()) ||
            (this.app.pmdrs.isFCA()) ||
            (this.app.dealPage.getTradeInEnable() && this.app.isVehicleTriumph()) ||
            (this.app.dealPage.getTradeInEnable() && this.app.isVehicleOnlyFinance(this.app.config.vehicle.make))
        ) {
            this.populateYearTradeInSelect();
        }
    }

    hideOrShowEstimatedTradeInValue() {
        let siteSettings = this.app.siteSettings;
        if (siteSettings.includeEstimatedTradeInValue) {
            let estimatedTradeInElem = this.getSelector(".contact-form-group.estimated-trade-in-value");
            DOMHelper.removeClass(estimatedTradeInElem, "d-none");
        }
    }

    hideOrShowVideo() {
        let overviewVideo = this.app.getYoutubeOverviewVideo();
        let imagesVideo = this.app.getYoutubeImagesVideo();

        let hideVideos = this.videoRemovedSTs.includes(this.app.pmdrs.config.accountId);        
        let isOverviewVideoValid = overviewVideo.includes('https');
        let isImagesVideoValid = imagesVideo.includes('https');

        if (hideVideos || !isOverviewVideoValid) {
            DOMHelper.addClass(this.getSelector("#trade-in-video"), "d-none");
        }

        if (hideVideos || !isImagesVideoValid) {
            DOMHelper.addClass(this.getSelector("#imagesTradeInModal"), "d-none");
        }
        
    }

    setBackground(make) {
        let background = make.toLowerCase() == "indian motorcycle" ? "indian-background" : "bmw-background";
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".addbtn.modal-openbtn")), background);
        DOMHelper.addClass(document.querySelector(this.app.getSelector(".ua-uploadsubmit")), background);
        DOMHelper.addClass(this.getSearchBtn(), background);
        DOMHelper.addClass(document.querySelector(this.getSelector(".apply-estimated-trade-in")), background);
    }

    setDecodedValues(year, make, model, trim) {
        DOMHelper.setValue(this.getSelector('.tradeYearField'), year);
        DOMHelper.setValue(this.getSelector('.tradeMakeField'), make);
        DOMHelper.setValue(this.getSelector('.tradeModelField'), model);
        DOMHelper.setValue(this.getSelector('.tradeTrimField'), trim);        
    }

    getDecodedValues() {
        return {
            year: document.querySelector(this.getSelector(".tradeYearField")).value,
            make: document.querySelector(this.getSelector(".tradeMakeField")).value,
            model: document.querySelector(this.getSelector(".tradeModelField")).value,
            trim: document.querySelector(this.getSelector(".tradeTrimField")).value,
        };
    }

    hideTradeInValueInformation() {
        let tradeInType = this.app.siteSettings.tradeInType ?? "manual";
        if (tradeInType != "manual") {
            DOMHelper.addClass(this.getSelector(".getTradeInValueSection"), "d-none");
        }
    }

    fireTradeInEvaluationEvent(){//datalayer
        let tValues = this.getDecodedValues();
        if (tValues.year && tValues.make && tValues.model && tValues.trim) {
            let key = tValues.year +  tValues.make +  tValues.model + tValues.trim;
            if(!this.tradeInEventFired[key]){
                this.app.pmDRSDatalayer.tradeInEvaluationEvent(PmDRSDatalayer.TRADE_IN_SECTION, tValues);
                this.tradeInEventFired[key] = true;
            }
        }
    }

    decodeVin(vin) {
        var $this = this;
        this.app.dealPage.showLoading();
        this.disableSearchBtn();
        var successMsg = `VIN ${vin} found.`;
        var errorMsg = "We could not find the VIN you sent, please fill out the form below to add your Trade In";

        let data = {
            vin: vin,
        };
        let successCallback = function (vehicle) {
            $this.vinFound = true;
            if (vehicle.length == 0) {
                $this.vinFound = false;
                console.log("has own property");
                return errorCallback();
            }
            vehicle = vehicle;
            // OLD version. populating dropdowns
            // let year = $this.getRetailingTypeSelect("year-trade-in");
            // let make = $this.getRetailingTypeSelect("make-name-trade-in");
            // let model = $this.getRetailingTypeSelect("model-trade-in");
            // let trim = $this.getRetailingTypeSelect("trim-trade-in");

            // year.value = vehicle.modelYear;
            // make.innerHTML = "<option value=" + vehicle.makeName + ">" + vehicle.makeName + "</option>";
            // model.innerHTML = '<option value="' + vehicle.modelName + '">' + vehicle.modelName + "</option>";
            // trim.innerHTML = '<option value="' + vehicle.trimName + '">' + vehicle.trimName + "</option>";

            // new version. using input:text
            DOMHelper.setValue($this.getSelector(".tradeYearField"), vehicle.year || "");
            DOMHelper.setValue($this.getSelector(".tradeMakeField"), vehicle.make || "");
            DOMHelper.setValue($this.getSelector(".tradeModelField"), vehicle.model || "");
            DOMHelper.setValue($this.getSelector(".tradeTrimField"), vehicle.trim || "");
            DealPageHelper.showTextInputSuccessMsg($this.getSelector(".ytiVin"), successMsg);
            $this.app.dealPage.hideLoading();
            $this.enableSearchBtn();
            //datalayer
            $this.fireTradeInEvaluationEvent();
        };
        let errorCallback = function () {                
            $this.vinFound = false;
            DealPageHelper.showTextInputError($this.getSelector(".ytiVin"), errorMsg);
            DOMHelper.setValue($this.getSelector(".tradeYearField"), "");
            DOMHelper.setValue($this.getSelector(".tradeMakeField"), "");
            DOMHelper.setValue($this.getSelector(".tradeModelField"),"");
            DOMHelper.setValue($this.getSelector(".tradeTrimField"), "");
            $this.app.dealPage.hideLoading();
            $this.enableSearchBtn();
        };
        this.VinDecode(successCallback, errorCallback, data);
    }

    NPAVinDecode(successCallback, errorCallback, data) {
        this.app.pmdrs.NPAApi.getVINDecode(
            data,
            (response) => {
                let vehicle = JSON.parse(response);
                if (vehicle.vinSuggestions[0] == undefined) {
                    console.error("error decoding vin");
                    errorCallback();
                    return;
                }
                successCallback(response);
            },
            errorCallback
        );
    }

    VinDecode(successCallback, errorCallback, data) {
        this.app.pmdrs.pmApiDtm.fullDecode(
            data,
            (response) => {
                let vehicle = JSON.parse(response);
                console.log(vehicle);
                successCallback(vehicle);
            },
            errorCallback,
        );
    }

    ChromeVinDecode(successCallback, errorCallback, data) {
        this.app.pmdrs.pmApiDtm.decodeByVin(
            data,
            (response) => {
                let vehicle = JSON.parse(response);
                console.log(vehicle);
                let attributes = vehicle["@attributes"];
                if (attributes.modelYear !== undefined && attributes.bestMakeName !== undefined) {
                    successCallback(attributes);
                } else {
                    errorCallback();
                    this.populateTradeInSelect();
                }
            },
            errorCallback
        );
    }

    populateYearTradeInSelect() {
        let yearSelect = this.getRetailingTypeSelect("year-trade-in");
        let makeNameSelect = this.getRetailingTypeSelect("make-name-trade-in");
        let modelSelect = this.getRetailingTypeSelect("model-trade-in");
        let trimSelect = this.getRetailingTypeSelect("trim-trade-in");
        // let tradeDataInput = document.querySelector(this.getSelector(".trade-in-no-vin-input-text"));
        // let tradeDataSelect = document.querySelector(this.getSelector(".trade-in-no-vin"));
        let options = "<option value='default'>Select Year</option>";
        let data = {
            modelYear: "modelYear",
        };
        this.app.pmdrs.pmApi.getYears(
            data,
            (response) => {
                console.log(response);
                // tradeDataInput.style.display = "none";
                // tradeDataSelect.style.display = "block";
                let years = JSON.parse(response);
                console.log(years);
                let integers = [];
                years.forEach((str) => {
                    integers.push(Number(str));
                });
                integers = integers.filter(Number.isInteger);
                integers = integers.filter((c, index) => {
                    return integers.indexOf(c) === index;
                });
                integers.sort(function (elemA, elemB) {
                    if (elemA > elemB) return -1;
                    if (elemA < elemB) return 1;
                    return 0;
                });
                for (let index in integers) {
                    options += "<option value='" + integers[index] + "'>" + integers[index] + "</option>";
                }
                yearSelect.innerHTML = options;
                makeNameSelect.innerHTML = "<option value='default'>Select Make</option>";
                modelSelect.innerHTML = "<option value='default'>Select Model</option>";
                trimSelect.innerHTML = "<option value='default'>Select Trim</option>";
            },
            (error) => {
                console.log(error);
                // tradeDataSelect.style.display = "none";
                // tradeDataInput.style.display = "block";
            }
        );
    }

    populateMakeNameSelect(type, year) {
        let makeNameSelect = this.getRetailingTypeSelect(type);
        let options = "<option value='default'>Select Make</option>";
        let data = {
            onlyMOT: true,
            makeName: "makeName",
            year: year,
        };
        if (this.app.pmdrs.isFCA()) {
            this.app.pmdrs.pmApiDtm.getMakeFCA(year, (response) => {
                let makes = JSON.parse(response);
                this.FCAMakeList = makes;
                makes = Object.values(makes);
                makes.sort(function (elemA, elemB) {
                    if (elemA < elemB) return - 1;
                    if (elemA > elemB) return -1;
                    return 0;
                });
                for (let index in makes) {
                    options += "<option value='" + makes[index] + "'>" + makes[index] + "</option>"
                }
                makeNameSelect.innerHTML = options;
            }, (error) => {});
        } else {
            this.app.pmdrs.pmApi.getMakeNameByYear(
                data,
                (response) => {
                    let makeNames = JSON.parse(response);
                    console.log(makeNames);
                    makeNames.sort(function (elemA, elemB) {
                        if (elemA < elemB) return -1;
                        if (elemA > elemB) return 1;
                        return 0;
                    });
                    for (let index in makeNames) {
                        options += "<option value='" + makeNames[index] + "'>" + makeNames[index] + "</option>";
                    }
                    makeNameSelect.innerHTML = options;
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }

    populateModelSelect(type, year, makeName) {
        let modelSelect = this.getRetailingTypeSelect(type);
        let options = "<option value='default'>Select Model</option>";
        let data = {
            onlyMOT: true,
            modelName: "modelName",
            makeName: makeName,
            year: year,
        };
        if (this.app.pmdrs.isFCA()) {
            let modelId = Object.entries(this.FCAMakeList).find(([key, val]) => val === makeName)?.[0] || null;
            console.log(modelId);
            this.app.pmdrs.pmApiDtm.getModeslFCA(year, modelId, 
                (success) => {
                    let models = JSON.parse(success);
                    models.sort(function (elemA, elemB) {
                        if (elemA < elemB) return -1;
                        if (elemA > elemB) return 1;
                        return 0;
                    });
                    for (let index in models) {
                        options += "<option value='" + models[index] + "'>" + models[index] + "</option>";
                    }
                    modelSelect.innerHTML = options;
                }, 
                (error) => {
                    console.log(error);
                }
            );
        } else {
            this.app.pmdrs.pmApi.getModelByYearAndMakeName(
                data,
                (response) => {
                    let models = JSON.parse(response);
                    models.sort(function (elemA, elemB) {
                        if (elemA < elemB) return -1;
                        if (elemA > elemB) return 1;
                        return 0;
                    });
                    for (let index in models) {
                        options += "<option value='" + models[index] + "'>" + models[index] + "</option>";
                    }
                    modelSelect.innerHTML = options;
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }

    populateTrimNameSelect(type, year, makeName, modelName) {
        let trimNameSelect = this.getRetailingTypeSelect(type);
        let options = "<option value='default'>Select Trim</option>";
        let data = {
            onlyMOT: true,
            trimName: "trimName",
            modelName: modelName,
            makeName: makeName,
            year: year,
        };
        if (this.app.pmdrs.isFCA()) {
            this.app.pmdrs.pmApiDtm.getTrimsFCA(year, makeName, modelName,
                (success) => {
                    let trims = JSON.parse(success);
                    console.log(trims);
                    trims.sort(function (elemA, elemB) {
                        if (elemA < elemB) return -1;
                        if (elemA > elemB) return 1;
                        return 0;
                    });
                    for (let index in trims) {
                        options += "<option value='" + trims[index] + "'>" + trims[index] + "</option>";
                    }
                    trimNameSelect.innerHTML = options;
                },
                (error) => {}
            );
        } else {
            this.app.pmdrs.pmApi.getTrimName(
                data,
                (response) => {
                    let models = JSON.parse(response);
                    models.sort(function (elemA, elemB) {
                        if (elemA < elemB) return -1;
                        if (elemA > elemB) return 1;
                        return 0;
                    });
                    for (let index in models) {
                        options += "<option value='" + models[index] + "'>" + models[index] + "</option>";
                    }
                    trimNameSelect.innerHTML = options;
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }

    setVideos() {
        let iframe = document.querySelector(this.getSelector("#iframe-youtube"));
        //SKIP IF NOT IFRAME
        if(iframe == null) return;

        let iframeImages = document.querySelector(this.app.getSelector("#iframe-images-youtube"));
        let overviewVideo = this.app.getYoutubeOverviewVideo();
        let imagesVideo = this.app.getYoutubeImagesVideo();
        if (iframe) {
            iframe.src = overviewVideo.replace("watch?v=", "embed/") + "?modestbranding=0&reo=0&showinfo=0";
        }
        if (iframeImages) {
            iframeImages.src = imagesVideo.replace("watch?v=", "embed/") + "?modestbranding=0&reo=0&showinfo=0";
        }
    }

    getRetailingTypeSelect(type) {
        return document.querySelector(this.getSelector(".retailing-" + type + "-select"));
    }

    validateToGetTradeInValue() {
        let fields = [".ytiMiles", ".tradein-condition"];
        let valid = true;
        let missing = [];

        fields.forEach((field) => {
            let elem = document.querySelector(this.getSelector(field));

            let elemValue = elem.value;
            if (elem.tagName.toLowerCase() === "select") {
                let tradeInErrorInline = document.querySelector(this.getSelector(".error-tradein-inline"));
                if (elemValue == "default") {
                    valid = false;
                    missing.push(field);
                    if (tradeInErrorInline) tradeInErrorInline.style.display = "inline";
                } else {
                    if (tradeInErrorInline) tradeInErrorInline.style.display = "none";
                }
            } else {
                if (elemValue.length === 0) {
                    this.showError(document.querySelector(this.getSelector(field)));
                    valid = false;
                    missing.push(field);
                } else {
                    this.hideError(document.querySelector(this.getSelector(field)));
                }
            }
        });

        if (!valid) {
            this.app.dealPage.missingFields.showMissingFields(missing);
            return false;
        }
        return true;
    }

    eventHandlers() {
        var $this = this;
        this.videosModal.setHideCallback(() => {
            let video = document.querySelector($this.app.getSelector(".youtube-video"));
            video.innerHTML += "";
        });

        this.videoImagesModal.setHideCallback(() => {
            let video = document.querySelector($this.app.getSelector(".youtube-video"));
            video.innerHTML += "";
        });

        DOMHelper.addHandler(this.getSelector("#tradein-include"), "change", (e) => {
            $this.includeTradeInTouched = true;
            $this.includeTradeIn = e.target.value == "yes";
            let display = $this.includeTradeIn ? "block" : "none";
            let tradeInType = $this.app.siteSettings.tradeInType ?? "manual";
            console.log($this.app.siteSettings);

            if ($this.app.pmdrs.isFCA()) {
                document.querySelector($this.getSelector(".tradein-fields-both")).style.display = display;
                // document.querySelector($this.getSelector(".tradein-fields-crs")).style.display = display;
                document.querySelector($this.getSelector(".tradein-fields-info")).style.display = display;
                document.querySelector($this.getSelector(".tradein-fields-manual")).style.display = display;
            }  else {
                document.querySelector($this.getSelector(".tradein-fields-both")).style.display = display;
                document.querySelector($this.getSelector(".tradein-fields-info")).style.display = display;
                document.querySelector($this.getSelector(".tradein-fields-manual")).style.display = display;
                // if (tradeInType == "manual") {
                //     document.querySelector($this.getSelector(".tradein-fields-manual")).style.display = display;
                // } else {
                //     // document.querySelector($this.getSelector(".tradein-fields-crs")).style.display = display;
                // }
            }
            
            //DATALAYER
            if($this.includeTradeIn){
                $this.app.shiftDatalayer.fireEvent('drTradeInShown');
            }
            $this.app.adobeDtmDatalayer.fireEvent('buttonClick',{btnText:'include-trade-in-' + ($this.includeTradeIn?'yes':'no') });

        });

        DOMHelper.addHandler(this.getSearchBtn(), 'click', (e) => {
            let vinInput = $this.getVinSearchInput();
            let vin = vinInput.value;
            $this.hideError(vinInput);
            $this.decodeVin(vin);
            // removing for HIN decode too. 06-17-25
            // if (vin.length == 17) {
            //     $this.decodeVin(vin);
            // }else{
            //     let errorMessage = "Invalid VIN format";
            //     DealPageHelper.showTextInputError(vinInput, errorMessage);
            //     $this.app.adobeDtmDatalayer.fireEvent('formError', {errorMessage});
            // }
        });

        DOMHelper.addHandler(this.getSelector(".ytiVin"), "change", (e) => {
            return;//changed to button
            var vin = e.target.value;
            if (vin.length == 17) {
                $this.decodeVin(vin);
            }
        });

        DOMHelper.addHandler(this.getSelector("#getTradeInValue"), "click", () => {
            let vin = document.querySelector($this.getSelector(".ytiVin")).value;
            let accessToken = this.app.widget.getNPAToken();
            let decodedValues = this.getDecodedValues();
            let mileage = document.querySelector(this.getSelector(".ytiMiles")).value;
            let condition = document.querySelector(this.getSelector(".tradein-condition")).value;
            let yearSelect = "",
                makeSelect = "",
                modelSelect = "",
                trimSelect = "";

            let data = {
                sessionToken: accessToken,
                vin: vin,
                vehicleBrand: decodedValues.make,
                vehicleModel: decodedValues.model,
                vehicleYear: decodedValues.year,
                useEstimates: true,
            };

            let tradeInType = this.app.siteSettings.tradeInType ?? "manual";
            if (tradeInType == "manual") {
                if (
                    vin.length == 0 &&
                    (decodedValues.make.length == 0 ||
                        decodedValues.model.length == 0 ||
                        decodedValues.year.length == 0)
                ) {
                    DealPageHelper.showElement("#tradeInValueMissingFields");
                    return;
                }
            } else {
                yearSelect = this.getRetailingTypeSelect("year-trade-in").value;
                makeSelect = $this.getRetailingTypeSelect("make-name-trade-in").value;
                modelSelect = $this.getRetailingTypeSelect("model-trade-in").value;
                trimSelect = $this.getRetailingTypeSelect("trim-trade-in").value;
                if (
                    vin.length == 0 &&
                    (yearSelect == "default" ||
                        makeSelect == "default" ||
                        modelSelect == "default" ||
                        trimSelect == "default")
                ) {
                    DealPageHelper.showElement("#tradeInValueMissingFields");
                    return;
                }
            }

            if (this.validateToGetTradeInValue()) {
                this.app.dealPage.showLoading();
                let successCallback = (response) => {
                    let value = JSON.parse(response);
                    console.log(value);
                    this.hideError(document.querySelector(this.getSelector(".ytiMiles")));
                    let tradeInErrorInline = document.querySelector(this.getSelector(".error-tradein-inline"));
                    if (tradeInErrorInline) tradeInErrorInline.style.display = "none";
                    if (value.success == true && value.getValueGuide.avgRetail != null) {
                        let tradeInValue = this.getTradeInRange(mileage, condition, value);
                        this.app.dealPage.tradeInValue = tradeInValue;
                        // this.app.config.vehicle.retailPrice -= minSale;
                        // this.app.config.vehicle.finalPrice -= minSale;
                        // this.app.dealPage.paymentSection.refreshAllPayments();
                        DOMHelper.setInnerHTML("#trade-in-value", tradeInValue);
                        DOMHelper.setInnerHTML(
                            this.app.dealPage.paymentSection.getSelector(".deal-trade-in-value"),
                            tradeInValue
                        );
                        DOMHelper.setInnerHTML(
                            this.app.dealPage.seeDetails.getSelector(".mypayment-trade-in-value"),
                            tradeInValue
                        );
                        let vehicleName = decodedValues.year + " " + decodedValues.make + " " + decodedValues.model;
                        this.app.dealPage.tradeInDisclaimer.updateValues(tradeInValue, condition, mileage, vehicleName);
                        this.app.dealPage.tradeInDisclaimer.tradeInModal.show();
                        DealPageHelper.showElement(this.getSelector("#tradeInValueField"));
                        DealPageHelper.hideElement("#tradeInValueError");
                        DealPageHelper.hideElement("#tradeInValueMissingFields");
                        DealPageHelper.showElement("#tradeInValueSuccess");
                    } else {
                        DealPageHelper.hideElement("#tradeInValueSuccess");
                        DealPageHelper.showElement("#tradeInValueError");
                        DealPageHelper.hideElement(this.getSelector("#tradeInValueField"));
                    }
                    $this.app.dealPage.hideLoading();
                };

                let errorCallback = () => {
                    DealPageHelper.hideElement("#tradeInValueSuccess");
                    DealPageHelper.showElement("#tradeInValueError");
                };
                if (tradeInType == "manual") {
                    data = {
                        sessionToken: accessToken,
                        vin: vin,
                        vehicleBrand: decodedValues.make,
                        vehicleModel: decodedValues.model,
                        vehicleYear: decodedValues.year,
                        useEstimates: true,
                    };
                } else {
                    let model = modelSelect + trimSelect;
                    data = {
                        sessionToken: accessToken,
                        vin: vin,
                        vehicleBrand: makeSelect,
                        vehicleModel: model.replace(/\s+/g, ""),
                        vehicleYear: yearSelect,
                        useEstimates: true,
                    };
                    console.log(data);
                }
                this.app.pmdrs.NPAApi.getTradeInValue(data, successCallback, errorCallback);
            } else {
                this.app.dealPage.missingFields.missingFieldsModal.show();
            }
        });

        //FORMAT
        DOMHelper.addHandler(this.getSelector(".ytiVin"), "keyup", (event) => {
            event.target.value = event.target.value.toUpperCase();
            event.target.value = FormatHelper.vinFormat(event.target.value);
        });

        // drap and drop functionality
        let preventDefaults = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        let drapDropArea = document.querySelector(this.app.getSelector("#drop-area"));
        ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            drapDropArea.addEventListener(eventName, preventDefaults);
        });

        // to highlight the drop area
        let highlight = function () {
            drapDropArea.classList.add("highlight");
        };
        let unhighlight = function () {
            drapDropArea.classList.remove("highlight");
        };
        ["dragenter", "dragover"].forEach((eventName) => {
            drapDropArea.addEventListener(eventName, highlight);
        });
        ["dragleave", "drop"].forEach((eventName) => {
            drapDropArea.addEventListener(eventName, unhighlight);
        });

        let showMessages = function (files) {
            let spanDragDrop = document.querySelector($this.app.getSelector("#span-drag-drop"));
            let spanDragDropStepTradeIn = document.querySelector($this.app.getSelector("#drs-open-drag-drop-text"));

            let selectedFiles = document.querySelector($this.app.getSelector("#selected-files"));
            selectedFiles.innerHTML = "";
            for (let i = 0; i < files.length; i++) {
                let tag = createAddedImage(files[i].name, i);
                selectedFiles.innerHTML += tag;
            }

            let text = files.length + " Images Added";
            spanDragDrop.textContent = text;
            spanDragDropStepTradeIn.textContent = text;
        };

        let fileSizeImageMsg = function() {
            let spanMaxSize = document.querySelector($this.app.getSelector("#span-file-size-msg"));
            spanMaxSize.textContent = "";
            spanMaxSize.style.color = "red";
            let text = "At least one of the selected images is larger than 5MB";
            spanMaxSize.textContent = text;
        }

        DOMHelper.addHandler($this.app.getSelector("#selected-files"), "click", (event) => {
            if (event.target.matches(".remove-image-tradein")) {
                let name = event.target.dataset["name"];
                console.log(name);
                let images = $this.imagesTradeIn;
                $this.imagesTradeIn = images.filter(function (img) {
                    return img.name !== name;
                });
                showMessages($this.imagesTradeIn);
            }
        });

        let createAddedImage = function (name, id) {
            let tag =
                "<li><span class='pmdrs-fa pmdrs-fa-check success success-icon-drag hide'></span><span>" +
                name +
                "</span>" +
                "<button type='button' class='remove-image-tradein' data-id='" +
                id +
                "' data-name='" +
                name +
                "'>Remove</button></li>";
            return tag;
        };

        let handleDrop = function (event) {
            let dataTransfer = event.dataTransfer;
            let files = dataTransfer.files;
            let auxLength = files.length + $this.imagesTradeIn.length;

            if (files.length > 8 || auxLength > 8) {
                console.log("handle drop condition event");
                alert("The maximum amount of images is 8, please select 8 or less");
            } else {
                // dealPage.imagesTradeIn = [];
                for (let i = 0; i < files.length; i++) {
                    $this.imagesTradeIn.push(files[i]);
                }
                let selectedFiles = document.querySelector($this.app.getSelector("#selected-files"));
                selectedFiles.innerHTML = "";
                showMessages($this.imagesTradeIn);
            }
        };
        drapDropArea.addEventListener("drop", handleDrop);

        let openDragDropModal = document.querySelector($this.app.getSelector("#openDragDropModal"));
        let openDragDropEvent = function (event) {
            event.preventDefault();
            $this.dragdropModal.show();
        };
        openDragDropModal.addEventListener("click", openDragDropEvent);

        // open OS folder
        let openFolder = document.querySelector($this.app.getSelector("#drag-drop-open-folder"));
        openFolder.addEventListener("click", (e) => {
            e.preventDefault();
            let inputFolder = document.querySelector($this.app.getSelector("#fileElem"));
            inputFolder.click();
        });

        let imagesTradeIn = document.querySelector($this.app.getSelector("#fileElem"));
        let imagesTradeInEvent = function (event) {
            let files = event.target.files;
            let filesLength = files.length;
            let auxLength = filesLength + $this.imagesTradeIn.length;
            const maxFileSize = 7 * 1024 * 1024; // 7MB limit
            if (filesLength > 8 || auxLength > 8) {
                event.preventDefault();
                event.target.value = "";
                alert("The maximum amount of images is 8, please select 8 or less");
            } else {
                // $this.imagesTradeIn = [];
                for (let i = 0; i < filesLength; i++) {
                    const fileSize = files[i].size;
                    if (fileSize < maxFileSize) {
                        $this.imagesTradeIn.push(files[i]);
                    } else {
                        fileSizeImageMsg();
                    }
                }
                let selectedFiles = document.querySelector($this.app.getSelector("#selected-files"));
                selectedFiles.innerHTML = "";
                showMessages($this.imagesTradeIn);
            }
        };
        imagesTradeIn.addEventListener("change", imagesTradeInEvent);

        // upload images in drag-and-drop modal
        let uploadButtonEvent = function () {
            let elems = document.querySelectorAll($this.getSelector(".success-icon-drag"));
            for (let i = 0; i < elems.length; i++) {
                setTimeout(() => {
                    elems[i].classList.remove("hide");
                    elems[i].style.transition = "opacity 1.5s linear 0s";
                    elems[i].style.opacity = 0.5;
                }, i * 1000);
            }
            setTimeout(() => {
                $this.dragdropModal.hide();
                let uploadImagesBtn = document.querySelector($this.getSelector("#openDragDropModal"));
                uploadImagesBtn.classList.remove("uploaded-images-button");
                uploadImagesBtn.classList.remove("uploaded-images-button-zero");
                if (elems.length == 0) {
                    uploadImagesBtn.classList.add("uploaded-images-button-zero");
                } else {
                    uploadImagesBtn.classList.add("uploaded-images-button");
                }
            }, elems.length * 1000 + 500);
        };

        DOMHelper.addHandler(this.app.getSelector("#footer-upload"), "click", () => {
            uploadButtonEvent();
        });

        // close drag-and-drop modal
        DOMHelper.addHandler(this.app.getSelector("#footer-close"), "click", () => {
            $this.dragdropModal.hide();
        });

        DOMHelper.addHandler(this.getSelector("#imagesTradeInModal"), "click", (event) => {
            $this.videoImagesModal.show();
            event.preventDefault();
        });

        if (this.app.dealPage.getTradeInEnable()) {
            let yearTradeInEvent = function () {
                let year = $this.getRetailingTypeSelect("year-trade-in").value;
                $this.populateMakeNameSelect("make-name-trade-in", year);
            };

            this.getRetailingTypeSelect("year-trade-in").addEventListener("change", yearTradeInEvent);

            let makeNameTradeInEvent = function () {
                let year = $this.getRetailingTypeSelect("year-trade-in").value;
                let makeName = $this.getRetailingTypeSelect("make-name-trade-in").value;
                $this.populateModelSelect("model-trade-in", year, makeName);
            };

            this.getRetailingTypeSelect("make-name-trade-in").addEventListener("change", makeNameTradeInEvent);

            let trimNameTradeInEvent = function () {
                let year = $this.getRetailingTypeSelect("year-trade-in").value;
                let makeName = $this.getRetailingTypeSelect("make-name-trade-in").value;
                let modelName = $this.getRetailingTypeSelect("model-trade-in").value;
                $this.populateTrimNameSelect("trim-trade-in", year, makeName, modelName);
            };

            this.getRetailingTypeSelect("model-trade-in").addEventListener("change", trimNameTradeInEvent);
        }

         DOMHelper.addHandler(this.getSelector(".tradeYearField")
         +", "+ this.getSelector(".tradeMakeField")
         +", "+ this.getSelector(".tradeModelField")
         +", "+ this.getSelector(".tradeTrimField")
         , "change", (event) => {
            $this.fireTradeInEvaluationEvent();
        });

        DOMHelper.addHandler(this.getSelector(".apply-estimated-trade-in"), "click", () => {
            let btn = document.querySelector($this.getSelector(".apply-estimated-trade-in"));
            let input = document.querySelector($this.getSelector(".estimated-trade-in-value input"));
            const paymentSection = $this.app.dealPage.paymentSection;

            if (DOMHelper.hasClass(btn, 'trade-in-applied')) {
                // UNAPPLY: reset back to editable
                DOMHelper.removeClass(btn, 'trade-in-applied');
                btn.innerHTML = 'Apply';
                input.disabled = false;
                paymentSection.tradeInData.tradeInEstimate = 0;
            } else {
                // APPLY: lock in the value
                let value = parseFloat(input.value) || 0;
                paymentSection.tradeInData.tradeInEstimate = value;
                DOMHelper.addClass(btn, 'trade-in-applied');
                btn.innerHTML = 'Estimated Trade In Applied: ' + FormatHelper.currencyFormat(value);
                input.disabled = true;
            }
            paymentSection.refreshAllPayments();
        });

        return; //stop while migrating to the new ui

        DOMHelper.addHandler(this.getSelector("#more-info-trade-in"), "click", (event) => {
            $this.videosModal.show();
            event.preventDefault();
            event.stopPropagation();
        });

        DOMHelper.addHandler(this.getSelector("#trade-in-disclaimer"), "click", () => {
            let disclaimer = document.querySelector($this.getSelector("#disclaimer-trade-in"));
            if (disclaimer.style.display == "none") {
                return (disclaimer.style.display = "block");
            }
            return (disclaimer.style.display = "none");
        });

        // remove images from imagesTradeiIn array
        // DOMHelper.addHandler(dealPage.dragDrop.getSelector(".remove-image-tradein"), "click", (event) => {
        //     event.preventDefault();
        //     console.log(event);
        //     alert(event.target.dataset["id"]);
        // });

        let includeTradeInEvent = function () {
            let tradeInRigth = document.querySelector($this.app.getSelector(".trade-in-right"));
            tradeInRigth.style.display = "block";
        };

        let doNotIncludeTradeInEvent = function () {
            let tradeInRigth = document.querySelector($this.app.getSelector(".trade-in-right"));
            tradeInRigth.style.display = "none";
        };

        let includeTradeInRadioButton = document.querySelector($this.app.getSelector("#includeTrade"));
        includeTradeInRadioButton.addEventListener("click", includeTradeInEvent);

        let DoNotIncludeTradeInRadioButton = document.querySelector($this.app.getSelector("#notIncludeTrade"));
        DoNotIncludeTradeInRadioButton.addEventListener("click", doNotIncludeTradeInEvent);
    }

    getTradeInRange(mileage, condition, tradeIn) {
        let mileages = [
            { min: 0, max: 7499 },
            { min: 7500, max: 14999 },
            { min: 15000, max: 24999 },
            { min: 25000, max: 39999 },
            { min: 40000, max: 1000000 },
        ];
        let conditions = {
            Excellent: { min: 80, max: 90 },
            Good: { min: 70, max: 80 },
            Fair: { min: 60, max: 70 },
        };
        let position = 0;
        for (let i = 0; i < mileages.length; i++) {
            if (mileage >= mileages[i].min && mileage <= mileages[i].max) {
                position = i;
                break;
            }
        }
        let conditionValue = conditions[condition];

        let selectedMileage = null;
        let selectedCondition = null;
        let tradeInMileages = tradeIn.getValueGuide.mileages;
        let tradeInConditions = tradeIn.getValueGuide.conditions;
        let summaries = tradeIn.getValueGuide.summaries;

        for (let i = 0; i < tradeInMileages.length; i++) {
            if (tradeInMileages[i].grade === conditionValue.min) {
                selectedMileage = tradeInMileages[i];
                break;
            }
        }

        for (let i = 0; i < tradeInConditions.length; i++) {
            if (tradeInConditions[i].grade === conditionValue.min) {
                selectedCondition = tradeInConditions[i];
                break;
            }
        }

        let mileageBreakdown = this.getMileageBreakdown(
            position,
            selectedMileage,
            selectedCondition,
            summaries,
            tradeIn
        );
        console.log(mileageBreakdown);
        return mileageBreakdown;
    }

    getMileageBreakdown(range, selectedMileage, selectedCondition, summaries, tradeIn) {
        let property = "mH" + (range + 1);
        let value = null;

        console.log(selectedCondition);
        console.log(selectedMileage);
        if (selectedCondition !== null && selectedMileage !== null) {
            value = selectedMileage[property];
        }

        if (value !== null) {
            return value;
        }
        if (value === null && selectedCondition === null) {
            if (summaries[0].minSale == 0) {
                return "$" + tradeIn.getValueGuide.roughTradeIn;
            }
            if (summaries[0].minSale == summaries[0].maxSale) {
                return "$" + summaries[0].minSale;
            }
            return "$" + summaries[0].minSale + " - $" + summaries[0].maxSale;
        }
        if (selectedCondition.minSale == selectedCondition.maxSale) {
            return "$" + selectedCondition.minSale;
        }
        return "$" + selectedCondition.minSale + " - $" + selectedCondition.maxSale;
    }

    getVinSearchInput(){
        return document.querySelector(this.getSelector(".ytiVin"));
    }

    getSearchBtn(){
        return document.querySelector(this.getSelector(".tradein-search-btn"));
    }

    getHtml() {
        return `<div class="trigger-element" data-index="2"></div>    
<div class="tradein-section deal-page-section" id="tradein-section">
    <div class="tradein-title">Trade-In</div>
    <div class="tradein-subtitle">Do you have a trade in? Enter your vehicle information and we will apply the trade in value to your order.</div>

    <div class="video-container" id="trade-in-video">
        <div style="padding:56.25% 0 0 0;position:relative;overflow:hidden;"><iframe src="" id="iframe-youtube" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:calc(100% + 60px);" title="Trade-in-video.mp4"></iframe></div>
    </div>
    
    <div class="contact-form">
        <div class="contact-form-group include-trade-in">
            <label class="contact-form-label" for="tradein-include">Include a Trade-In</label>
            <select id="tradein-include" class="contact-form-input" type="text">
                <option value="yes">Yes</option>
                <option value="no" selected>No</option>
            </select>
        </div>

        <div class="tradein-fields">
            <div class="tradein-fields-info" style="display: none;">
                <div class="contact-form-text"><strong>Add your trade-in vehicle information</strong></div>

                <div class="contact-form-group">
    <label class="contact-form-label">VIN Lookup
        <span></span>
    </label>
    
    <input class="contact-form-input ytiVin"
    @@multiple type="text"
    accept="@@accept"
    name="tradeInvinField"
    placeholder="Enter your vehicle's VIN" @@required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeInvinField">This field is required.</p>
    <p class="description"></p>
</div>


                <button type="button" class="color-white tradein-search-btn">Search</button>
                <br>
                <div class="">Or manually enter your vehicle info</div>
                <br>
            </div>

            <div class="tradein-fields-manual" style="display: none;">
                <div class="contact-form-group">
    <label class="contact-form-label">Year
        <span></span>
    </label>
    
    <input class="contact-form-input tradeYearField"
    @@multiple type="number"
    accept="@@accept"
    name="tradeYearField"
    placeholder="Enter Year" @@required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeYearField">This field is required.</p>
    <p class="description"></p>
</div>

                <div class="contact-form-group">
    <label class="contact-form-label">Make
        <span></span>
    </label>
    
    <input class="contact-form-input tradeMakeField"
    @@multiple type="text"
    accept="@@accept"
    name="tradeMakeField"
    placeholder="Enter Make" @@required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeMakeField">This field is required.</p>
    <p class="description"></p>
</div>

                <div class="contact-form-group">
    <label class="contact-form-label">Model
        <span></span>
    </label>
    
    <input class="contact-form-input tradeModelField"
    @@multiple type="text"
    accept="@@accept"
    name="tradeModelField"
    placeholder="Enter Model" @@required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeModelField">This field is required.</p>
    <p class="description"></p>
</div>

                <div class="contact-form-group">
    <label class="contact-form-label">Trim
        <span></span>
    </label>
    
    <input class="contact-form-input tradeTrimField"
    @@multiple type="text"
    accept="@@accept"
    name="tradeTrimField"
    placeholder="Enter Trim" @@required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeTrimField">This field is required.</p>
    <p class="description"></p>
</div>

            </div>

            <div class="tradein-fields-crs" style="display: none;">
                <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Year</label>
    <select class="contact-form-input retailing-year-trade-in-select" name="tradeYearField">
    </select>
</div>
                <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Make</label>
    <select class="contact-form-input retailing-make-name-trade-in-select" name="tradeMakeField">
    </select>
</div>
                <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Model</label>
    <select class="contact-form-input retailing-model-trade-in-select" name="tradeModelField">
    </select>
</div>
                <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Trim</label>
    <select class="contact-form-input retailing-trim-trade-in-select" name="tradeTrimField">
    </select>
</div>
            </div>

            <div class="tradein-fields-both" style="display: none;">
                <div class="contact-form-group">
    <label class="contact-form-label">Mileage
        <span></span>
    </label>
    
    <input class="contact-form-input ytiMiles"
    @@multiple type="number"
    accept="@@accept"
    name="tradeMileageField"
    placeholder="Enter Mileage" required
    maxlength="@@maxlength" inputmode="@@inputmode">

    <p class="error-input tradeMileageField">This field is required.</p>
    <p class="description"></p>
</div>

    
                <label class="contact-form-label" style="display: inline;">Condition</label>
                <label class="error-tradein-inline">This field is required</label>
                <select class="tradeConditionField contact-form-input" type="text" name="tradeConditionField" style="margin-bottom: 10px;">
                    <option value="default">Select Condition</option>
                    <option value="Excellent">Excellent</option>
                    <option value="Good">Good</option>
                    <option value="Fair">Fair</option>
                </select>

                <div class="contact-form-group estimated-trade-in-value d-none">
                    <label class="contact-form-label">Estimated Trade-In Value
                        <span></span>
                    </label>

                    <input class="contact-form-input" type="number" name="tradeInEstimatedValue" placeholder="Enter Your Estimated Trade-In Value">
                    <button type="button" class="apply-estimated-trade-in color-white">Apply</button>
                </div>
                <!-- 
                <div class="contact-form-group">
    <label class="contact-form-label" for="payment-creditscore">Condition</label>
    <select class="contact-form-input retailing-condition-trade-in-select" name="tradeConditionField">
    </select>
</div>        
         -->
                <div class="contact-form-group">
                    <label class="contact-form-label" for="tradein-images">Upload Image(s) - <a id="imagesTradeInModal" href="#">Learn More</a></label>
                    <div class="uploadbox">
                        <div class="txtcol" id="drs-open-drag-drop-text">0 Images Added</div>
                        <a class="addbtn modal-openbtn" id="openDragDropModal">Add</a>
                    </div>                
                </div>
                <div class="contact-form-group">
                    <label class="contact-form-label" for="tradein-date">Schedule a date to bring your vehicle for a trade-in evaluation, Your selected date is a tentative place holder and we will confirm your appointment prior to bringing in your vehicle.</label>
                    <input name="tradeDateField" class="contact-form-input" type="date" id="tradein-date">
                </div>
    
                <!-- <div class="contact-form-text">Schedule a date to bring your vehicle for a trade-in evaluation, Your selected date is a tentative place holder and we will confirm your appointment prior to bringing in your vehicle.</div> -->
                <div class="contact-form-group">
                    <label class="contact-form-label" for="tradein-additional-info">Additional Information</label>
                    <textarea name="tradeCommentsField" id="tradein-additional-info" class="contact-form-input" type="text" rows="4" /></textarea>     
                </div>
    
                <!-- <div class="contact-form-group getTradeInValueSection">
                    <button type="button" id="getTradeInValue" class="color-white">Get Trade-In Value</button>
                    <p style="display: none; color: black; margin: 10px 0;" id="tradeInValueSuccess">Trade-In Value added</p>
                    <p style="display: none; color: red;" id="tradeInValueError">Trade-In Value Failed</p>
                    <p style="display: none; color: red;" id="tradeInValueMissingFields">Enter VIN or Make, Model and Trim</p>
                    <p style="display: none; color: #0062ff; font-size: 17px;" id="tradeInValueField">The value of your Trade-In is: <span style="color: #0062ff;" id="trade-in-value"></span></p>
                </div> -->
            </div>

        </div>
    </div>
</div>
`;
    }

    showError(domElement) {
        return (domElement.nextElementSibling.style.display = "block");
    }

    hideError(domElement) {
        return (domElement.nextElementSibling.style.display = "none");
    }

    getVideoModalHtml() {
        return `<div class="start-videos-tradein-modal">
    <div class="videos-tradein-header">
        <h3>Trade In Overview</h3>
        <hr>
    </div>

    <div class="youtube-video">
        <div class="overview">
            <iframe src="about:blank" frameborder="0" id="iframe-overview-youtube"></iframe>
        </div>
    </div>
</div>`;
    }

    getVideoImagesModalHtml() {
        return `<div class="start-videos-images-modal">
    <div class="videos-images-header">
        <h3>Trade In Images</h3>
        <hr>
    </div>

    <div class="youtube-video">
        <div class="images">
            <iframe src="about:blank" frameborder="0" id="iframe-images-youtube"></iframe>
        </div>
    </div>
</div>`;
    }

    getDragAndDropHtml() {
        return `<div class="start-drag-and-drop-modal" id="modalUploadArea">
   <!--  <div class="header-drag-drop">
        <h3>Upload Your Trade-In Images</h3>
        <hr>
    </div>
    <form id="drag-drop-form">
        <div id="drop-area">
            <input type="file" multiple accept="image/*" id="fileElem" name="vehicleImages">
            <p id="drag-drop-open-folder" class="button">Select Images</p>
            <div class="selected-files" id="selected-files">
                <p>Images selected: </p>
            </div>
            <p id="span-drag-drop"></p>
        </div>
        <div class="drag-drop-footer">
            <button type="button" class="footer-upload" id="footer-upload">Upload</button>
            <button type="button" class="footer-close" id="footer-close">Close</button>
        </div>
    </form> -->

    <div class="ua-title">Upload Your Trade-In Images</div>
    <form id="drag-drop-form">
        <div class="ua-box" id="drop-area">
            <input type="file" multiple accept="image/*" id="fileElem" name="vehicleImages">            
            <div>Select up to 8 images</div>
            <div>Max Image Size: 7MB</div>
            <div class="ua-uploadselect">
                <a id="drag-drop-open-folder" class="button">Select Images</a>
            </div>
            <div class="selected-files" id="selected-files">
                <p>Images selected: </p>
            </div>
            <p id="span-drag-drop"></p>
            <p id="span-file-size-msg"></p>
        </div>
        <div class="ua-uploadsubmit" id="footer-upload">Upload</div>
        <div class="submit-button-close bmwdrs-close" id="footer-close">Close</div>
    </form> 
</div>
`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAt + " " + selector);
    }

    enableSearchBtn(){
        let searchBtn = this.getSearchBtn();
        DOMHelper.removeClass(searchBtn, 'disabled');
    }

    disableSearchBtn(){
        DOMHelper.addClass(this.getSearchBtn(), 'disabled');
    }


    /**
     * to disable the whole section
     */
    disable() {
        this.enabled = false;
        DOMHelper.addClass(this.getSelector("#tradein-include"), "disabled");
        DOMHelper.addClass(this.getSelector(""), "disabled-section");
    }

    /**
     * to enable the whole section
     */
    enable() {
        this.enabled = true;
        DOMHelper.removeClass(this.getSelector("#tradein-include"), "disabled");
        DOMHelper.removeClass(this.getSelector(""), "disabled-section");
    }
}
